<template>
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_3886_728)">
            <path
                d="M12.502 3.81983C10.4663 3.61809 8.41832 3.51416 6.37647 3.51416C5.16603 3.51416 3.9556 3.57529 2.74516 3.69756L1.49805 3.81983"
                stroke="#F9F9F9" stroke-width="0.933333" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M4.86035 3.20237L4.99484 2.40153C5.09266 1.82076 5.16602 1.38672 6.19917 1.38672H7.80085C8.834 1.38672 8.91348 1.84522 9.00518 2.40764L9.13967 3.20237"
                stroke="#F9F9F9" stroke-width="0.933333" stroke-linecap="round" stroke-linejoin="round" />
            <path
                d="M11.1875 5.75159L10.7901 11.9077C10.7229 12.8675 10.6679 13.6133 8.96225 13.6133H5.0375C3.33189 13.6133 3.27687 12.8675 3.20962 11.9077L2.81226 5.75159"
                stroke="#F9F9F9" stroke-width="0.933333" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M5.97913 10.251H8.01486" stroke="#F9F9F9" stroke-width="0.933333" stroke-linecap="round"
                stroke-linejoin="round" />
            <path d="M5.47156 7.80566H8.52821" stroke="#F9F9F9" stroke-width="0.933333" stroke-linecap="round"
                stroke-linejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_3886_728">
                <rect width="14" height="14" fill="white" transform="translate(0 0.5)" />
            </clipPath>
        </defs>
    </svg>

</template>